module.exports = __webpack_public_path__ + "img/icon-viajeros-modal.813b28bc.svg";